<template>
  <v-container  class="pa-4">
    <v-row class="px-0" align="stretch">
      
      <v-col 
        cols="12" 
        sm="6" 
        md="4" 
        lg="4"
        v-for="app in categorias" 
        :key="app.id"
        class="pa-1"
      >
        <v-card
          class="rounded-lg category-card cursor-pointer"
          outlined
          hover
          height="100"
          @click="verCategoria(app.categoria)"
        >
          <v-img
            :src="getImageCategUrl(app.imgCategoria)"
            height="100%"
            class="white--text align-end"
          >
            <!-- Gradiente superpuesto para legibilidad -->
            <div class="fill-height d-flex justify-center align-center bg-gradient-overlay">
              <span class="subtitle-1 font-weight-bold text-center px-2">
                {{ app.categoria }}
              </span>
            </div>
            
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['categorias'])
  },
  data() {
    return {
      // Sin cambios
    }
  },
  methods: {
    verCategoria(item) {
      this.$emit('productos-categoria', item)
    },
  }
}
</script>

<style scoped>
.category-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;
}

.bg-gradient-overlay {
  background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 100%);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/* Asegura que el texto sea legible */
.subtitle-1 {
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
  letter-spacing: 0.5px;
}
</style>